export type RosterTypeCount = { name: string; count: number };

export function parseRosterThaliTypeCounts(raw: unknown): RosterTypeCount[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.filter(
    (x): x is RosterTypeCount =>
      x != null &&
      typeof x === "object" &&
      typeof (x as { name?: unknown }).name === "string" &&
      typeof (x as { count?: unknown }).count === "number"
  );
}

export function formatRosterBreakdownParts(counts: RosterTypeCount[]): string[] {
  return counts.map((x) => `${x.name}: ${x.count}`);
}

export const ROSTER_EMPTY = {
  loading: "Loading…",
  noMenu: "No roster for this date.",
  none: "No distributors on the roster for this date.",
  filter: "No distributors match this filter.",
} as const;

export function rosterEmptyMessage(params: {
  loading: boolean;
  hasDailyMenu: boolean;
  rowCount: number;
  hasSearch: boolean;
}): string | null {
  if (params.loading) return ROSTER_EMPTY.loading;
  if (!params.hasDailyMenu) return ROSTER_EMPTY.noMenu;
  if (params.rowCount === 0) {
    return params.hasSearch ? ROSTER_EMPTY.filter : ROSTER_EMPTY.none;
  }
  return null;
}
